import formatters from "./formatters";

export const DEFAULT_DATE_FORMAT_TIMEZONE = "YYYY/MM/DD HH:mm zz";
export const DEFAULT_DATE_TIMEZONE = "America/Chicago";

export const ALERTS_FORM_COLUMNS = {
  created_at: {
    clickable: false,
    label: "Created",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
    sort: "date",
    formatter: formatters.createdDate,
  },
  alertid: {
    clickable: false,
    label: "Alert Id",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
  },
  risk_type: {
    clickable: false,
    label: "Risk Type",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
  },
  requirement_value: {
    clickable: false,
    label: "Value",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
  },
  threshold_value: {
    clickable: false,
    label: "Threshold",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
  },
  sliceid: {
    clickable: false,
    label: "Slice Id",
    isVisible: true,
    resizable: true,
    width: 230,
    disabled: true,
  },
};
